import Vue from "vue";

export const filterInt = (value: string | number, defaultValue = "1"): string => {
  if (typeof value === "number") {
    return value.toString();
  }
  if (!value || isNaN(parseFloat(value))) return defaultValue;
  return parseInt(value.replace(" ", "").replace(",", ".")).toString();
};

Vue.filter("int", filterInt);
